import script from "./FooterView.vue?vue&type=script&setup=true&lang=ts"
export * from "./FooterView.vue?vue&type=script&setup=true&lang=ts"

import "./FooterView.vue?vue&type=style&index=0&id=7feba506&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7feba506"]])

export default __exports__